var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _path, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _path2, _rect16, _circle, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDriversLicenseBackBad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 124,
    viewBox: "0 0 124 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3752_81074)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.90625,
    y: 13.374,
    width: 1.06653,
    height: 7.46567,
    fill: "#C8253C"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5.90625,
    y: 14.4404,
    width: 1.06652,
    height: 7.46569,
    transform: "rotate(-90 5.90625 14.4404)",
    fill: "#C8253C"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 117.359,
    y: 13.374,
    width: 1.06652,
    height: 7.46569,
    transform: "rotate(90 117.359 13.374)",
    fill: "#C8253C"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 116.289,
    y: 13.374,
    width: 1.06653,
    height: 7.46567,
    fill: "#C8253C"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 5.90625,
    y: 110.962,
    width: 1.06652,
    height: 7.46569,
    transform: "rotate(-90 5.90625 110.962)",
    fill: "#C8253C"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 117.359,
    y: 110.962,
    width: 1.06653,
    height: 7.46567,
    transform: "rotate(-180 117.359 110.962)",
    fill: "#C8253C"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 6.97656,
    y: 110.962,
    width: 1.06653,
    height: 7.46567,
    transform: "rotate(-180 6.97656 110.962)",
    fill: "#C8253C"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 117.359,
    y: 109.895,
    width: 1.06652,
    height: 7.46569,
    transform: "rotate(90 117.359 109.895)",
    fill: "#C8253C"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3752_81074)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M140.234 87.1191C140.234 88.7013 138.569 89.9844 136.515 89.9844L17.002 89.9844C14.948 89.9844 13.2824 88.7013 13.2822 87.1191L13.2822 27.6377C13.2822 25.0109 15.4114 22.8811 18.0381 22.8809L136.515 22.8809C138.569 22.8809 140.234 24.1639 140.234 25.7461L140.234 87.1191Z",
    fill: "url(#paint0_linear_3752_81074)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 13.2812,
    y: 39.2031,
    width: 126.952,
    height: 12.6952,
    fill: "black",
    fillOpacity: 0.54
  }))), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 25.3904,
    height: 1.95255,
    rx: 0.976273,
    transform: "matrix(1 -1.27572e-08 -5.19345e-06 1 20.5391 30.1357)",
    fill: "#83888E",
    fillOpacity: 0.5
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 29.9381,
    height: 1.95255,
    rx: 0.976273,
    transform: "matrix(1 -2.20797e-08 -3.00066e-06 1 20.5391 62.7803)",
    fill: "#83888E",
    fillOpacity: 0.4
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    width: 29.9381,
    height: 1.95255,
    rx: 0.976273,
    transform: "matrix(1 -2.20797e-08 -3.00066e-06 1 20.5391 71.8486)",
    fill: "#83888E",
    fillOpacity: 0.4
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    width: 35.9656,
    height: 1.95255,
    rx: 0.976273,
    transform: "matrix(1 -2.20797e-08 -3.00066e-06 1 20.5391 80.916)",
    fill: "#83888E",
    fillOpacity: 0.4
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    width: 30.0334,
    height: 1.95255,
    rx: 0.976273,
    transform: "matrix(1 -3.3845e-08 -1.95756e-06 1 20.5391 67.3145)",
    fill: "#83888E",
    fillOpacity: 0.4
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    width: 24.5447,
    height: 1.95255,
    rx: 0.976273,
    transform: "matrix(1 -3.3845e-08 -1.95756e-06 1 20.5391 76.3818)",
    fill: "#83888E",
    fillOpacity: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "luminosity"
    },
    opacity: 0.1
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M123.461 60.0596C130.723 60.0596 136.609 65.9463 136.609 73.208C136.609 80.4698 130.723 86.3564 123.461 86.3564C121.444 86.3564 119.533 85.9015 117.825 85.0898C119.459 84.3137 120.907 83.2108 122.085 81.8652C122.533 81.9358 122.992 81.9736 123.46 81.9736C128.301 81.9736 132.227 78.0492 132.227 73.208C132.226 68.3669 128.301 64.4424 123.46 64.4424C122.992 64.4424 122.533 64.4792 122.085 64.5498C120.907 63.2044 119.459 62.1012 117.825 61.3252C119.533 60.5136 121.444 60.0596 123.461 60.0596ZM113.565 64.5498C115.173 64.803 116.634 65.4938 117.825 66.4951C115.912 68.1031 114.694 70.5131 114.694 73.208C114.694 75.9031 115.912 78.313 117.825 79.9209C116.634 80.9221 115.172 81.6121 113.565 81.8652C111.54 79.5524 110.312 76.5237 110.312 73.208C110.313 69.8921 111.54 66.8628 113.565 64.5498Z",
    fill: "black",
    fillOpacity: 0.6
  })))), /*#__PURE__*/React.createElement("foreignObject", {
    x: 70.8601,
    y: 88.5711,
    width: 35.4282,
    height: 35.4282
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(1.48px)",
      clipPath: "url(#bgblur_1_3752_81074_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    "data-figma-bg-blur-radius": 2.95238,
    x: 73.8125,
    y: 91.5234,
    width: 29.5238,
    height: 29.5238,
    rx: 14.7619,
    fill: "#DF2B44",
    fillOpacity: 0.2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 88.5751,
    cy: 106.285,
    r: 11.8095,
    fill: "#DF2B44"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M92.3008 101.014C92.8498 100.465 93.7401 100.465 94.2891 101.014C94.8378 101.563 94.8378 102.453 94.2891 103.002L90.7842 106.507L94.2891 110.012C94.8376 110.561 94.8379 111.451 94.2891 112C93.7402 112.549 92.8499 112.549 92.3008 112L88.7959 108.495L85.291 112C84.7421 112.549 83.8517 112.549 83.3027 112C82.7538 111.451 82.7539 110.561 83.3027 110.012L86.8076 106.507L83.3027 103.002C82.7537 102.453 82.7537 101.563 83.3027 101.014C83.8518 100.465 84.742 100.465 85.291 101.014L88.7959 104.519L92.3008 101.014ZM88.7959 107.659V107.66V107.659Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3752_81074",
    x: -20.0138,
    y: -3.27951,
    width: 184.03,
    height: 124.181,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4.75643,
    dy: 2.37822
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 14.2693
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.109804 0 0 0 0 0.239216 0 0 0 0 0.392157 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3752_81074"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3752_81074",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_1_3752_81074_clip_path",
    transform: "translate(-70.8601 -88.5711)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 73.8125,
    y: 91.5234,
    width: 29.5238,
    height: 29.5238,
    rx: 14.7619
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3752_81074",
    x1: 15.936,
    y1: 57.7516,
    x2: 179.398,
    y2: 44.2513,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C9D1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.607628,
    stopColor: "#DAE2EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBF0F7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3752_81074"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 124,
    height: 124,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDriversLicenseBackBad);
export default __webpack_public_path__ + "static/media/DriversLicenseBackBad.2111cc57fa8a2bac3a20b784eb3f22ae.svg";
export { ForwardRef as ReactComponent };